export default "__VITE_ASSET__DNxEDWym__";